var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSuccessIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.833374 7.99967C0.833374 4.05687 4.05723 0.833008 8.00004 0.833008C11.9428 0.833008 15.1667 4.05687 15.1667 7.99967C15.1667 11.9425 11.9428 15.1663 8.00004 15.1663C4.05723 15.1663 0.833374 11.9425 0.833374 7.99967ZM8.00004 1.83301C4.60952 1.83301 1.83337 4.60915 1.83337 7.99967C1.83337 11.3902 4.60952 14.1663 8.00004 14.1663C11.3906 14.1663 14.1667 11.3902 14.1667 7.99967C14.1667 4.60915 11.3906 1.83301 8.00004 1.83301Z",
    fill: "#37D660"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.1846 5.76004C11.3797 5.95547 11.3794 6.27206 11.184 6.46715L7.40397 10.2405C7.20866 10.4354 6.89232 10.4353 6.69718 10.2402L4.81051 8.3535C4.61525 8.15824 4.61525 7.84166 4.81051 7.64639C5.00577 7.45113 5.32235 7.45113 5.51762 7.64639L7.05104 9.17982L10.4775 5.75942C10.6729 5.56433 10.9895 5.56461 11.1846 5.76004Z",
    fill: "#37D660"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessIcon);
export default __webpack_public_path__ + "static/media/success-icon.53f8df044f033e7ac3e63cd05eaff6cd.svg";
export { ForwardRef as ReactComponent };